import React from 'react'

import { MdArrowForwardIos } from 'react-icons/md'

import { useWindowSize } from '../../../hooks/useWindowSize'
import { Profesor, Student } from '../../../types'

import { ListContainer, ItemWithImage, Photo } from './styles'

const ListWithImage = ({
  disabled,
  list,
  activeId,
  onClick,
  hasSeparation = true,
}: {
  disabled: boolean
  list: Profesor[] | Student[] | null
  activeId?: string | null
  onClick: (index: number) => void
  hasSeparation?: boolean
}) => {
  const { isMobile } = useWindowSize()

  return (
    <ListContainer>
      {list &&
        list.map((item, i) => {
          return (
            <ItemWithImage
              className={`${disabled ? 'disabled' : ''} ${activeId === item.uid ? 'active' : ''}`}
              key={i}
              onClick={() => onClick(i)}
              $hasSeparation={hasSeparation}
            >
              <Photo
                $image={
                  item.image && item.image.length > 0
                    ? item.image
                    : '/assets/profile.png'
                }
              />

              <p className="name">
                {item.name} {item.lastname}
              </p>
              {isMobile && activeId === item.uid && (
                <div className="icon">
                  <MdArrowForwardIos />
                </div>
              )}
            </ItemWithImage>
          )
        })}
    </ListContainer>
  )
}

export default ListWithImage
